<div class="page-container confirm-page">
  <div class="payment-page-content-wrap">
    <div class="inner-section payment-page-content">
      <div class="payments-form-wrap">
        <div class="tabs-item tab-menu">
          <div class="subscription-title">
            Вы действительно хотите отменить подписку?
          </div>
        </div>

        <div class="payment-footer">
          <a [routerLink]="'/'"  class="button">
            Не отменять
          </a>
          <button  (click)="confirm()" class="button">
            отменить
          </button>
        </div>
      </div>
      <img class="payment-footer-img confirm-footer" src="assets/images/ul-kit/footer-logos.png" alt="">
    </div>
  </div>

</div>
